import React, { useContext, useEffect, useRef, useState } from 'react';
import './SaleInvoice.css';
import { useParams } from 'react-router-dom';
import { ConfigContext } from '../../Context/ConfigContext';
import { ProgressSpinner } from 'primereact/progressspinner';
import axios from 'axios';
import { formatedDate } from '../../Helper/constent';
import SaleReturnPrint from '../PrintHelper/SaleReturnPrint';

const SaleReturnInvoice = () => {
  const { sale_return_id } = useParams();
  const toast = useRef(null);
  const [dataLoading, setDataLoading] = useState(true);
  const [invoiceData, setInvoiceData] = useState(null);
  const [products, setProducts] = useState([]);
  const [user, setUser] = useState(null);
  const { apiUrl, apiHeadersJson } = useContext(ConfigContext);
  const headers = apiHeadersJson;

  const handlePrint = () => {
    window.print();
  };

  const GetList = async () => {
    setDataLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/Reports/GetSaleReturnInvoice`, { params: { sale_return_id }, headers });
      const { success, data, prodcuts, user, message } = response.data;

      if (success) {
        setInvoiceData(data);
        setProducts(prodcuts);
        setUser(user[0]);
      } else {
        toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
      }
    } catch (error) {
      console.log('Error fetching invoice:', error);
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    GetList();
  }, []);

  if (dataLoading) {
    return (
      <div className="loading-container">
        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
      </div>
    );
  }

  const saleDetails = invoiceData[0];

  return (
    <>
      <SaleReturnPrint saleDetails={saleDetails} products={products} user={user} isShow={true} />
      <button onClick={handlePrint} className="sale-print-button">Print</button>
    </>
  );
};

export default SaleReturnInvoice;
